import React, { Component } from 'react';
import classNames from 'classnames';
import {
  Nav, NavItem, NavLink, TabContent, TabPane
} from 'reactstrap';
import Lib from '../../../commons/lib';
import FelhasznalokContent from './FelhasznaloContent';
import FelhasznalokCsoportContent from './FelhasznaloCsoportContent';
import CustomTooltip from '../../../components/Tooltip/CustomTooltip';
import getTooltip from './FelhasznaloTooltips';

class FelhasznalokBase extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      activeTab: '1',
    };
  }

  toggle = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab });
    }
  };
  
  render() {
    let cardStyle = {
      padding: 10,
    };
    
    return (
      <div className="animated fadeIn">
        <div className="card">
          <div className="card-header">Felhasználók</div>
          <div className="row" style={cardStyle}>
            <div className="col-md-12">
              <Nav tabs>
                {this.props.globals.hasRole(['CONFIG_USER'], true) && (
                  <NavItem>
                    <NavLink
                      href="#"
                      className={classNames({ active: this.state.activeTab === '1', })}
                      onClick={() => { this.toggle('1'); }}
                    >
                      Felhasználó
                      <CustomTooltip text={getTooltip('felhasznalo')} id="felhasznaloTT" />
                    </NavLink>
                  </NavItem>
                )}
                {this.props.globals.hasRole(['CONFIG_USER'], true) && (
                  <NavItem>
                    <NavLink
                      href="#"
                      className={classNames({ active: this.state.activeTab === '2', })}
                      onClick={() => { this.toggle('2'); }}
                    >
                      Csoport
                      <CustomTooltip text={getTooltip('csoport')} id="csoportTT" />
                    </NavLink>
                  </NavItem>
                )}
              </Nav>
              <TabContent activeTab={this.state.activeTab}>
                {this.props.globals.hasRole(['CONFIG_USER'], true) && (
                  <TabPane tabId="1">
                    <FelhasznalokContent {...this.props} globals={this.props.globals} />
                  </TabPane>
                )}
                {this.props.globals.hasRole(['CONFIG_USER'], true) && (
                  <TabPane tabId="2">
                    <FelhasznalokCsoportContent {...this.props} globals={this.props.globals} />
                  </TabPane>
                )}
              </TabContent>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default FelhasznalokBase;
